export default "__VITE_ASSET__35RKayUv__"